import { AppEnvironmentData } from './environment.type';

export const environment: AppEnvironmentData = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  // These values are populated via the dev.yml file during Github Action builds
  releaseName: 'elevance-ivr-upgrades-3558',
  buildNumber: '3.3.006-beta.20250618205548',
};
